import { Button, Grid, Modal, TextField, Typography } from "@mui/material";
import { useState } from "react";

export interface SetUserPasswordModalProps {
  open: boolean;
  userName: string;

  onConfirm: (newPassword: string) => void;
  onCancel: () => void;
};

export const SetUserPasswordModal = (props: SetUserPasswordModalProps) => {
  const [password, setPassword] = useState<string>('');
  const [confirmPassword, setConfirmPassword] = useState<string>('');

  return (
    <Modal
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      open={props.open}
      onClose={props.onCancel}
    >
      <Grid
        sx={(theme) => ({
          backgroundColor: theme.palette.background.paper,
          borderRadius: 2,
          padding: 3,
          minWidth: 400,
          boxShadow: 24,
          outline: 'none',
        })}
        spacing={4}
        container
      >
        <Grid size={12}>
          <Typography color="textPrimary" variant="h6">Update User Password</Typography>
        </Grid>
        <Grid size={12}>
          <Typography color="textPrimary">Submitting this will change the password for user {props.userName}.</Typography>
        </Grid>
        <Grid size={12}>
          <TextField
            fullWidth
            label="Password"
            type="password"
            value={password ?? ''}
            onChange={(e) => setPassword(e.target.value)}
          />
        </Grid>
        <Grid size={12}>
          <TextField
            fullWidth
            label="Confirm Password"
            type="password"
            value={confirmPassword ?? ''}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
        </Grid>
        <Grid size={12} container spacing={2} flexDirection='row-reverse'>
          <Grid size={2}>
            <Button
              variant="contained"
              disabled={!password || password !== confirmPassword}
              onClick={() => {
                props.onConfirm(password);
              }}
            >Confirm</Button>
          </Grid>
          <Grid size={2}>
            <Button
              variant="contained"
              color="error"
              onClick={props.onCancel}
            >Cancel</Button>
          </Grid>
        </Grid>
      </Grid>
    </Modal >
  )
}